import React, { useEffect, useState } from "react";
import { Container, Table } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import { Row, Form } from "reactstrap";
import Select from "react-select";
import indiaFlag from "../../../assets/images/flags/india.png";
import UkFlag from "../../../assets/images/flags/uk.png";
import "../../../assets/css/Sales/Sales.css";
import axios from "axios";
import Loader from "pages/Separate/Loader";
import configure from "configure";
import Swal from "sweetalert2";

const AddProposal = () => {
  const terms = [];
  const [fixButtons, setFixButtons] = useState(false);
  const [testingRows, setTestingRows] = useState([{}]);
  const [breakdownRows, setBreakdownRows] = useState([{}]);
  const [termsRows, setTermsRows] = useState([
    {
      no: "1",
      service: "Project duration",
      currency: "₹",
      total: "",
    },
    {
      no: "2",
      service: "(Service Name)",
      currency: "₹",
      total: "",
    },
    {
      no: "3",
      service: "Domain, Hosting, and SSL (Annual Charges)",
      currency: "₹",
      total: "",
    },
  ]);
  const [timelineRows, setTimelineRows] = useState([
    { phase: "Discovery & Strategy", duration: "", deliverables: "" },
    { phase: "UI/UX Design", duration: "", deliverables: "" },
    { phase: "Development", duration: "", deliverables: "" },
    { phase: "Content Integration", duration: "", deliverables: "" },
    { phase: "QA & Testing", duration: "", deliverables: "" },
    { phase: "Deployment", duration: "", deliverables: "" },
  ]);

  const [relatedClient, setRelatedClient] = useState([]);
  const navigate = useNavigate();

  document.title = "Add General Proposal | Zithas Crm";

  const onAddTestingRow = () => {
    setTestingRows([...testingRows, {}]);
  };
  const onDeleteTestingRow = (index) => {
    const newInputs = [...testingRows];
    newInputs.splice(index, 1);
    setTestingRows(newInputs);
  };

  const onAddBreakdownRow = () => {
    setBreakdownRows([...breakdownRows, {}]);
  };
  const onDeleteBreakdownRow = (index) => {
    const newInputs = [...breakdownRows];
    newInputs.splice(index, 1);
    setBreakdownRows(newInputs);
  };

  const onAddTermsRow = () => {
    const modifiedRows = [...termsRows];
    modifiedRows.push({ id: modifiedRows.length + 1 });
    setTermsRows(modifiedRows);
  };
  const onDeleteTermsRow = (id) => {
    var modifiedRows = [...termsRows];
    modifiedRows = modifiedRows.filter((x) => x["id"] !== id);
    setTermsRows(modifiedRows);
  };
  const [template, setTemplate] = useState({ value: "1", label: "Template 1" });

  const onTimelineChange = (e, key) => {
    const updated = [...timelineRows];
    updated[key] = { ...updated[key], [e.target.name]: e.target.value };
    setTimelineRows(updated);
  };

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true);
    } else {
      setFixButtons(false);
    }
  });

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 50,
    }),
  };

  const related_option = [
    { label: "Lead", value: "lead" },
    { label: "Customer", value: "customer" },
    { label: "Introducer", value: "introducer" },
  ];

  const template_options = [
    { label: "Template 1", value: "1" },
    { label: "Blank Template", value: "2" },
  ];

  const [isLoading, setLoading] = useState(false);
  const [location_option, setLocationOption] = useState([]);
  const [status_option, setStatusOption] = useState([]);
  const [assign_option, setAssignOption] = useState([]);
  const [currency_option, setCurrencyOption] = useState([]);
  // const [location, setLocation] = useState({ value: 2, label: "Location 2" });
  const [location, setLocation] = useState(null);
  const [proposal_title, setProposalTitle] = useState("");
  const [proposal_subtitle, setProposalSubTitle] = useState("");
  const [status, setStatus] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [date, setDate] = useState("");
  const [till_date, setTillDate] = useState("");
  const [related, setRelated] = useState("");
  const [lead_option, setLeadOption] = useState([]);
  const [company_name, setCompany_name] = useState("");
  const [address, setAddress] = useState("");
  const [website, setWebsite] = useState("");
  const [person_name, setPersonName] = useState("");
  const [contact_name_options, setContactPersionOptions] = useState([]);
  const [person_email, setPersonEmail] = useState("");
  const [person_phone, setPersonPhone] = useState("");
  const [provider_company, setProviderCompany] = useState(
    "Zithas Technologies Ltd.",
  );
  const [provider_address, setProviderAddress] = useState("");
  const [provider_website, setProviderWebsite] = useState("www.zithas.co.uk");
  const [provider_person, setProviderPerson] = useState("");
  const [provider_phone, setProviderPhone] = useState("");
  const [provider_email, setProviderEmail] = useState("");
  const [assign, setAssign] = useState([]);
  const [deliverables, setDeliverables] = useState([]);
  const [cost_break, setCostBreak] = useState([]);
  const [terms_row, setTermsRow] = useState([]);
  const [conclusion_email, setConclusionEmail] = useState("");
  const [conclusion_phone, setConclusionPhone] = useState("");
  const [source_id, setSourceId] = useState([]);
  const [allIntroducers, setIntroducerOption] = useState([]);
  const [introducerId, setIntroducerId] = useState([]);
  const [project_objective, setProjectObjective] = useState("");
const [isGeneratingObjective, setIsGeneratingObjective] = useState(false);

  useEffect(() => {
    fetchLocation();
    fetchCurrency();
    onStatus();
  }, []);

  const fetchLocation = async () => {
    setLoading(true);
    try {
      await axios({
        method: "get",
        url: `${configure.nodeApi}/locations`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLocationOption(
          res.data.locations.map((obj) => ({
            label: obj.location,
            value: obj.id,
            link: obj?.Link,
          })),
        );
       
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const onChangeCountry = async (e) => {
    setLocation(e);
  setLoading(true);
  

  if (e.value == 1) {
    setProviderCompany("Zithas Technologies Pvt. Ltd.");
    setProviderWebsite("www.zithas.com");
  } else if (e.value == 2) {
    setProviderCompany("Zithas Technologies Ltd.");
    setProviderWebsite("www.zithas.co.uk");
  }

  const formData = new FormData();
  formData.append("country_id", e.value);
  try {
    await axios({
      method: "post",
      url: `${configure.apiUrl}/lead_belong`,
      data: formData,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    }).then((res) => {
      setAssignOption(
        res.data.data.assigned?.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      );
      setIntroducerOption(
        res?.data?.data?.introducer?.map((obj) => ({
          label: obj.company,
          value: obj.id,
        })),
      );
      setLoading(false);
    });
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};

  const fetchCurrency = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${configure.nodeApi}/currency`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setCurrencyOption(
          response.data.data.currency.map((item) => ({
            label: item.currency,
            value: item.id,
            symbol: item.symbol,
          })),
        );
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onChangeRelated = async (e) => {
    setRelatedClient(e);
    setLoading(true);
    setPersonEmail("");
    setPersonName("");
    setPersonPhone("");
    setSourceId([]);
    setCompany_name("");
    setWebsite("");
    setAddress("");
    const formData = new FormData();
    formData.append("related", e.value);
    // formData.append("location", location.value);
    formData.append("location", location?.value ?? "");
    try {
      await axios({
        method: "post",
        url: `${configure.nodeApi}/related`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          if (e.value == "introducer") {
            setLeadOption(
              res.data.data.map((obj) => ({
                value: obj.id,
                label: obj.company,
                address: obj.address,
                details: obj.person_details,
                website: obj.website,
              })),
            );
          } else {
            setLeadOption(
              res.data.data.map((obj) => ({
                value: obj.id,
                label:
                  obj.company +
                  " - " +
                  (obj.person_details[0]
                    ? obj.person_details[0]?.person_name
                    : "NA") +
                  " - " +
                  obj?.id,
                companyName: obj.company,
                address: obj.address,
                details: obj.person_details,
                website: obj.website,
                asigned: obj.asigned,
              })),
            );
          }
        }
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const onClientInfo = async (e) => {
    setSourceId(e);
    setCompany_name(e?.companyName);

    // ── Auto-fill date/status only if empty ──
    if (!status?.value) {
      const inProgress = status_option.find((o) => o.value == 2);
      if (inProgress) setStatus(inProgress);
    }
    if (!date) {
      const today = new Date();
      setDate(today.toISOString().split("T")[0]);
    }
    if (!till_date) {
      const future = new Date();
      future.setDate(future.getDate() + 15);
      setTillDate(future.toISOString().split("T")[0]);
    }

    if (relatedClient?.value === "lead") {
      // ── Contact person options + auto-select first person ──
      const contactOptions = (e.details || []).map((person) => ({
        label: person.person_name,
        value: person,
      }));
      setContactPersionOptions(contactOptions);

      // Auto-select first contact person and fill email/phone
      if (contactOptions.length > 0) {
        const firstContact = contactOptions[0];
        setPersonName(firstContact);
        setPersonEmail(
          firstContact.value?.person_email || firstContact.value?.email || "",
        );
        setPersonPhone(
          firstContact.value?.person_phone || firstContact.value?.phone || "",
        );
      }

      setAddress(e.address || "");
      setWebsite(e.website || "");

        if (e.asigned) {
          console.log("e.asigned:", e.asigned);
          console.log("assign_option:", assign_option);
    const matchedAssign = assign_option.find(
      (o) => String(o.value) === String(e.asigned)
    );
    console.log("matchedAssign:", matchedAssign); 
    if (matchedAssign) {
      await onStaffDetail(matchedAssign);
    }
  }

      // ── Fetch full lead detail ──
      try {
      const leadDetailRes = await axios.get(
        `${configure.apiUrl}/lead/${e.value}`,
        { headers: { Accept: "application/json" } }
      );
      const leadDetail = leadDetailRes.data?.data?.[0];

      if (leadDetail?.introducer_id) {
        const matchedIntroducer = allIntroducers.find(
          (o) => String(o.value) === String(leadDetail.introducer_id)
        );
        if (matchedIntroducer) setIntroducerId(matchedIntroducer);
      }
    } catch (err) {
      console.error("lead detail fetch error:", err);
    }

      // ── Fetch RFP and populate tables ──
      try {
        const rfpRes = await axios.get(
          `${configure.nodeApi}/get_rfp_by_lead/${e.value}`,
          { headers: { Accept: "application/json" } },
        );

        if (rfpRes.data.success && rfpRes.data.data) {
          const rfp = rfpRes.data.data;

          if (rfp.currency) {
            const matchedCurrency = currency_option.find(
              (o) => o.label === rfp.currency,
            );
            if (matchedCurrency) setCurrency(matchedCurrency);
          }

          const features = (() => {
            try {
              const r = rfp.features;
              return typeof r === "string" ? JSON.parse(r) : r || [];
            } catch {
              return [];
            }
          })();
          const timing = (() => {
            try {
              const r = rfp.timing;
              return typeof r === "string" ? JSON.parse(r) : r || {};
            } catch {
              return {};
            }
          })();
          const services = (() => {
            try {
              const r = rfp.services;
              return typeof r === "string" ? JSON.parse(r) : r || [];
            } catch {
              return [];
            }
          })();

          if (!features.length) return;

          const ROLES = ["dev", "ba", "qa"];
          const featureHours = (serviceId, fi, subCount) =>
            ROLES.reduce(
              (acc, role) =>
                acc +
                Array.from({ length: subCount }, (_, si) =>
                  Number(timing[`${serviceId}|${fi}|${si}|${role}`] || 0),
                ).reduce((a, b) => a + b, 0),
              0,
            );

          // Deliverables
          const deliveryRows = [];
          for (const svc of features) {
            const svcHours = svc.subtitles.reduce(
              (acc, sub, fi) =>
                acc + featureHours(svc.serviceId, fi, sub.features.length),
              0,
            );
            const svcWeeks = svcHours > 0 ? Math.ceil(svcHours / 40) : "";
            const svcTitle =
              services.find(
                (s) =>
                  String(s.value) === String(svc.serviceId) ||
                  String(s.id) === String(svc.serviceId),
              )?.title || String(svc.serviceId);
            deliveryRows.push({
              "sr.no": String(deliveryRows.length + 1),
              milestone: svcTitle,
              estimatedtime: svcWeeks ? String(svcWeeks) : "",
            });
          }
          setTestingRows(deliveryRows.length ? deliveryRows : [{}]);
          setDeliverables(deliveryRows.length ? deliveryRows : [{}]);

          // Cost Breakdown
          const breakRows = [];
          let srCounter = 1;
          for (const svc of features) {
            for (let fi = 0; fi < svc.subtitles.length; fi++) {
              const subtitle = svc.subtitles[fi];
              const totalHrs = featureHours(
                svc.serviceId,
                fi,
                subtitle.features.length,
              );
              breakRows.push({
                sr_no: String(srCounter++),
                description: subtitle.title || "",
                totalcost: totalHrs > 0 ? String(totalHrs) : "",
              });
              for (const subFeature of subtitle.features) {
                breakRows.push({
                  sr_no: "",
                  description: subFeature.title || "",
                  totalcost: "",
                });
              }
            }
          }
          setBreakdownRows(breakRows.length ? breakRows : [{}]);
          setCostBreak(breakRows.length ? breakRows : [{}]);

          // Terms
          const totalHoursAll = features.reduce(
            (acc, svc) =>
              acc +
              svc.subtitles.reduce(
                (a2, sub, fi) =>
                  a2 + featureHours(svc.serviceId, fi, sub.features.length),
                0,
              ),
            0,
          );
          const totalWeeks =
            totalHoursAll > 0 ? Math.ceil(totalHoursAll / 40) : "";
          const rfpGrandTotal = rfp.grand_total || "";
          const rfpCurrSymbol = rfp.currency_symbol || "";

          const newTermsRows = [
            {
              no: "1",
              service: "Project duration",
              currency: rfpCurrSymbol,
              total: totalWeeks
                ? `${totalWeeks} Week${totalWeeks > 1 ? "s" : ""}`
                : "",
            },
            {
              no: "2",
              service: proposal_title || "(Service Name)",
              currency: rfpCurrSymbol,
              total: rfpGrandTotal
                ? String(parseFloat(rfpGrandTotal).toFixed(2))
                : "",
            },
            {
              no: "3",
              service: "Domain, Hosting, and SSL (Annual Charges)",
              currency: rfpCurrSymbol,
              total: "",
            },
          ];
          setTermsRows(newTermsRows);
          setTermsRow(newTermsRows);
        }
      } catch (err) {
        console.error("RFP auto-populate error:", err);
      }
    } else if (relatedClient?.value === "customer") {
      const contactOptions = (e.details || []).map((person) => ({
        label: person.person_name,
        value: person,
      }));
      setContactPersionOptions(contactOptions);
      setPersonEmail(e.details?.[0]?.email || "");
      setPersonName(e.details?.[0]?.person_name || "");
      setPersonPhone(e.details?.[0]?.phone || "");
      setAddress(e.address || "");
      setWebsite(e.website || "");
    }
  };

  const onStaffDetail = async (e) => {
    setProviderPerson(e.label);
    setAssign(e);
    setLoading(true);
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/show/${e.value}`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setProviderPhone(response.data.data.staff.phone_number);
        setProviderEmail(response.data.data.staff.email);

        let city, state, country;
        Object.keys(response.data.data.staff).forEach((obj) => {
          switch (obj) {
            case "ctname":
              city =
                response.data.data.staff[obj] != null
                  ? response.data.data.staff[obj]
                  : "-";
              break;
            case "sname":
              state =
                response.data.data.staff[obj] != null
                  ? response.data.data.staff[obj]
                  : "-";
              break;
            case "cname":
              country =
                response.data.data.staff[obj] != null
                  ? response.data.data.staff[obj]
                  : "-";
              break;
          }
        });

        setProviderAddress(`${city}, ${state}, ${country}`);
        setConclusionEmail(response.data.data.staff.email);
        setConclusionPhone(response.data.data.staff.phone_number);
        setLoading(false);
      });
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const onStatus = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${configure.apiUrl}/proposal_status`,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {
        setStatusOption(
          response.data.data.map((obj) => ({ value: obj.id, label: obj.name })),
        );
      });
    } catch (err) {
      console.log(err);
    }
  };

  const generateObjective = async () => {
  if (!source_id?.value) {
    return Swal.fire({ icon: "warning", text: "Please select a lead first" });
  }
  setIsGeneratingObjective(true);
  try {
    const rfpRes = await axios.get(
      `${configure.nodeApi}/get_rfp_by_lead/${source_id.value}`,
      { headers: { Accept: "application/json" } }
    );
    if (!rfpRes.data.success || !rfpRes.data.data) {
      return Swal.fire({ icon: "warning", text: "No RFP found for this lead to generate objective" });
    }
    const rfp = rfpRes.data.data;
    const features = (() => { try { const r = rfp.features; return typeof r === "string" ? JSON.parse(r) : (r || []); } catch { return []; } })();
    const services = (() => { try { const r = rfp.services; return typeof r === "string" ? JSON.parse(r) : (r || []); } catch { return []; } })();

    const res = await axios.post(
      `${configure.nodeApi}/generate_project_objective`,
      { company_name: company_name || "The Client", features, services },
      { headers: { Accept: "application/json" } }
    );
    if (res.data.success) {
      setProjectObjective(res.data.objective);
    } else {
      Swal.fire({ icon: "error", text: "Failed to generate objective" });
    }
  } catch (err) {
    console.error("generateObjective error:", err);
    Swal.fire({ icon: "error", text: "Failed to generate objective" });
  } finally {
    setIsGeneratingObjective(false);
  }
};

  const onSrNo = (e, key) => {
    let values = [...testingRows];
    values[key][e.target.name] = e.target.value;
    setTestingRows(values);
    setDeliverables(values);
  };
  const onDescription = (e, key) => {
    let values = [...testingRows];
    values[key][e.target.name] = e.target.value;
    setTestingRows(values);
    setDeliverables(values);
  };
  const onTime = (e, key) => {
    let values = [...testingRows];
    values[key][e.target.name] = e.target.value;
    setTestingRows(values);
    setDeliverables(values);
  };

  // const onSrnoBreak = (e, key) => {
  //   let values = [...breakdownRows];
  //   values[key][e.target.name] = e.target.value;
  //   setCostBreak(values);
  // };
  // const onDescriptionCost = (e, key) => {
  //   let values = [...breakdownRows];
  //   values[key][e.target.name] = e.target.value;
  //   setCostBreak(values);
  // };
  // const onTimeCost = (e, key) => {
  //   let values = [...breakdownRows];
  //   values[key][e.target.name] = e.target.value;
  //   setCostBreak(values);
  // };
  const onSrnoBreak = (e, key) => {
  let values = [...breakdownRows];
  values[key][e.target.name] = e.target.value;

  setBreakdownRows(values);
  setCostBreak(values);
};

const onDescriptionCost = (e, key) => {
  let values = [...breakdownRows];
  values[key][e.target.name] = e.target.value;

  setBreakdownRows(values);
  setCostBreak(values);
};

const onTimeCost = (e, key) => {
  let values = [...breakdownRows];
  values[key][e.target.name] = e.target.value;

  setBreakdownRows(values);
  setCostBreak(values);
};

  const onSrNoTerms = (e, key) => {
    let values = [...termsRows];
    values[key][e.target.name] = e.target.value;
    setTermsRow(values);
  };
  const onParticular = (e, key) => {
    let values = [...termsRows];
    values[key][e.target.name] = e.target.value;
    setTermsRow(values);
  };
  const onCurrency = (e, key) => {
    let values = [...termsRows];
    values[key][e.target.name] = e.target.value;
    setTermsRow(values);
  };
  const onTotal = (e, key) => {
    let values = [...termsRows];
    values[key][e.target.name] = e.target.value;
    setTermsRow(values);
  };

  const onAddProposal = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    formData.append("proposaltitle", proposal_title);
    formData.append("proposalsubtitle", proposal_subtitle);
    formData.append("currency", currency?.value);
    formData.append("date", date);
    formData.append("opentill", till_date);
    formData.append("related", relatedClient?.value);
    formData.append("companyname", company_name);
    formData.append(
      "contactname",
      person_name?.label ? person_name?.label : person_name,
    );
    formData.append("address", address);
    formData.append("clientcontact", person_phone);
    formData.append("email", person_email);
    formData.append("website", website);
    formData.append("assigned", assign?.value);
    formData.append("company2", provider_company);
    formData.append("contactnumber", provider_phone);
    formData.append("address1", provider_address);
    formData.append("providermail", provider_email);
    formData.append("contact", provider_person);
    formData.append("website1", provider_website);
    formData.append("deliverytestin", JSON.stringify(deliverables));
    formData.append("term", JSON.stringify(terms_row));
    // Save only rows where Sr No is filled in — skips auto-added sub-feature rows
// const filteredCostBreak = (cost_break || []).filter(
//   (row) => row?.sr_no != null && String(row.sr_no).trim() !== ""
// );
formData.append("costbreakdow", JSON.stringify(cost_break));
    // formData.append("costbreakdow", JSON.stringify(cost_break));
    formData.append("location", location.value);
    formData.append("status", status?.value);
    formData.append("conclusion_email", conclusion_email);
    formData.append("conclusion_contact", conclusion_phone);
    formData.append("source_name", source_id?.value);
    formData.append("type", "General");
    formData.append("introducer_id", introducerId?.value);
    formData.append("template", template?.value || "1");
    formData.append("timeline", JSON.stringify(timelineRows));
    formData.append("project_objective", project_objective);

    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/add_proposal`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        Swal.fire({
          icon: "success",
          text: "Proposal Added Successfully",
        }).then((data) => {
          navigate(`${configure.appUrl}sales/proposal`);
        });
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-3">
        <Container fluid>
          <Breadcrumbs
            title={"Dashboard"}
            breadcrumbItem={"Add General Proposal"}
          />
          <Row className="px-1">
            <Form onSubmit={onAddProposal}>
              <div
                className={`flex-column fixed-buttons pt-2 ${
                  fixButtons ? "d-flex" : "d-none"
                }`}
              >
                <button className="btn btn-purple fix-btn btn-label pe-0">
                  <i className="fas fa-save me-2 label-icon"></i>
                  <span>Save</span>
                </button>
                <a
                  onClick={() => navigate(-1)}
                  className="btn btn-red fix-btn btn-label pe-0"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  <span>Cancel</span>
                </a>
              </div>
             

              <Row className="bg-white px-2 py-4 shadow mb-3 align-items-end">
{/* Location */}
<div className="col-md-3 mb-3 mb-md-0">
  <label>Location <span className="text-danger">*</span></label>
  <div 
    className="d-flex flex-wrap gap-3"
    style={{ height: "38px", alignItems: "center" }} 
  >
    {location_option.map((item, i) => {
      const isSelected = String(location?.value) === String(item.value);
      return (
        <div
          key={i}
          onClick={() => onChangeCountry(item)}
          style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
        >
          <div style={{
            width: "18px",
            height: "18px",
            borderRadius: "50%",
            border: `2px solid ${isSelected ? "#7B5EA7" : "#aaa"}`,
            backgroundColor: isSelected ? "#7B5EA7" : "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}>
            {isSelected && (
              <div style={{
                width: "7px",
                height: "7px",
                borderRadius: "50%",
                backgroundColor: "#fff",
              }} />
            )}
          </div>
          <img
            src={item?.link}
            alt={item?.label || "flag"}
            width="28"
            height="18"
            style={{ display: "block", borderRadius: "2px" }}
          />
        </div>
      );
    })}
  </div>
</div>

  {/* Introducer */}
  <div className="col-md-3 mb-3 mb-md-0">
    <label htmlFor="">Introducer</label>
    <Select
      placeholder="Select Introducer"
      className="basic-multi-select"
      classNamePrefix="select"
      styles={colourStyles}
      options={allIntroducers}
      value={introducerId}
      onChange={(e) => setIntroducerId(e)}
    />
  </div>

  {/* Template */}
  <div className="col-md-3 mb-3 mb-md-0">
    <label htmlFor="">Proposal Template <span className="text-danger">*</span></label>
    <Select
      placeholder="Select Template"
      className="basic-multi-select"
      classNamePrefix="select"
      styles={colourStyles}
      options={template_options}
      value={template}
      onChange={(e) => setTemplate(e)}
    />
  </div>

  {/* Buttons */}
  <div className="col-md-3 mb-3 mb-md-0 text-end">
    <button className="btn ms-md-2 btn-save btn-label">
      <i className="fas fa-save me-1 label-icon"></i> save
    </button>
    <button
      onClick={(e) => {
        e.preventDefault();
        navigate(-1);
      }}
      className="btn ms-md-2 btn-red btn-label"
    >
      <i className="dripicons-cross me-2 icon-center label-icon"></i>
      CANCEL
    </button>
  </div>

</Row>

              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Service Information</h5>
                <div className="col-md-6 mt-2 mb-3">
                  <label htmlFor="">Proposal Title</label>
                  <input
                    type="text"
                    placeholder="Enter Proposal Title"
                    style={{ backgroundColor: "#f8f6ff" }}
                    className="form-control"
                    value={proposal_title}
                    onChange={(e) => {
                      setProposalTitle(e.target.value);
                      let values = [...termsRows];
                      values[1]["service"] = e.target.value;
                      setTermsRow(values);
                    }}
                  />
                </div>
                <div className="col-md-6 mt-2 mb-3">
                  <label htmlFor="">Proposal Subtitle</label>
                  <input
                    type="text"
                    placeholder="Enter Proposal Subtitle"
                    style={{ backgroundColor: "#f8f6ff" }}
                    className="form-control"
                    value={proposal_subtitle}
                    onChange={(e) => setProposalSubTitle(e.target.value)}
                  />
                </div>
                {/* <div className="col-md-3 mb-3 mb-md-0"> */}
                <div
                  className={`${
                    template?.value === "2" ? "col-md-2" : "col-md-3"
                  } mb-3 mb-md-0`}
                >
                  <label htmlFor="">Status</label>
                  <Select
                    placeholder="Select Status"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={status_option}
                    value={status}
                    onChange={(e) => setStatus(e)}
                  />
                </div>
                {/* <div className="col-md-3 mb-3 mb-md-0"> */}
                <div
                  className={`${
                    template?.value === "2" ? "col-md-2" : "col-md-3"
                  } mb-3 mb-md-0`}
                >
                  <label htmlFor="">Currency</label>
                  <Select
                    placeholder="Select Currency"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={currency_option}
                    value={currency}
                    onChange={(e) => setCurrency(e)}
                  />
                </div>
                <div className="col-md-2 mb-3 mb-md-0">
                  <label htmlFor="">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                </div>
                <div className="col-md-2 mb-3 mb-md-0">
                  <label htmlFor="">Open Till</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => setTillDate(e.target.value)}
                    value={till_date}
                  />
                </div>
                <div className="col-md-2 mb-3 mb-md-0">
                  <label htmlFor="">Related</label>
                  <Select
                    placeholder="Select Related"
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={related_option}
                    onChange={(e) => onChangeRelated(e)}
                  />
                </div>
                {template?.value == "2" && relatedClient?.length != 0 ? (
                  <div className="col-md-2 mb-3 mb-md-0">
                    <label htmlFor="">{relatedClient?.label}</label>
                    <Select
                      placeholder="Select"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={colourStyles}
                      options={lead_option}
                      value={source_id}
                      onChange={(e) => onClientInfo(e)}
                    />
                  </div>
                ) : null}
              </Row>

              {template?.value !== "2" && (
                <Row>
                  <div className="col-md-6 pe-md-4">
                    <Row className="bg-white px-2 py-4 shadow mb-3">
                      <h5 className="mb-3">Client Information</h5>
                      {relatedClient?.length != 0 ? (
                        <div className="col-md-4 mt-2 mb-3">
                          <label htmlFor="">{relatedClient?.label}</label>
                          <Select
                            placeholder="Select"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            styles={colourStyles}
                            options={lead_option}
                            value={source_id}
                            onChange={(e) => onClientInfo(e)}
                          />
                        </div>
                      ) : null}
                      <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">Company Name</label>
                        <input
                          type="text"
                          placeholder="Enter Company Name"
                          className="form-control"
                          value={company_name}
                          onChange={(e) => setCompany_name(e.target.value)}
                        />
                      </div>
                      {relatedClient?.label == "Introducer" ? (
                        <div className="col-md-4 mt-2 mb-3">
                          <label htmlFor="">Contact Person</label>
                          <input
                            type="text"
                            placeholder="Enter Contact Person"
                            className="form-control"
                            value={person_name}
                            onChange={(e) => setPersonName(e.target.value)}
                          />
                        </div>
                      ) : (
                        <div className="col-md-4 mt-2 mb-3">
                          <label htmlFor="">Contact Person</label>
                          <Select
                            placeholder="Select"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            styles={colourStyles}
                            options={contact_name_options}
                            value={person_name}
                            onChange={(e) => {
                              setPersonName(e);
                              setPersonEmail(e.value.person_email);
                              setPersonPhone(e.value.person_phone);
                            }}
                          />
                        </div>
                      )}
                      <div className="col-md-12 mb-3">
                        <label htmlFor="">Address</label>
                        <input
                          type="text"
                          placeholder="Enter Address"
                          className="form-control"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4 mb-3 mb-md-0">
                        <label htmlFor="">Contact</label>
                        <input
                          type="text"
                          placeholder="Enter Contact"
                          className="form-control"
                          value={person_phone}
                          onChange={(e) => setPersonPhone(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4 mb-3 mb-md-0">
                        <label htmlFor="">Email Id</label>
                        <input
                          type="email"
                          placeholder="Enter Email Id"
                          className="form-control"
                          value={person_email}
                          onChange={(e) => setPersonEmail(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4 mb-3 mb-md-0">
                        <label htmlFor="">Website</label>
                        <input
                          type="text"
                          placeholder="Enter URL"
                          className="form-control"
                          value={website}
                          onChange={(e) => setWebsite(e.target.value)}
                        />
                      </div>
                    </Row>
                  </div>
                  <div className="col-md-6 ps-md-3">
                    <Row className="bg-white px-2 py-4 shadow mb-3">
                      <h5 className="mb-3">Provider Information</h5>
                      <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">Assigned</label>
                        <Select
                          placeholder="Select Status"
                          className="basic-multi-select"
                          classNamePrefix="select"
                          styles={colourStyles}
                          options={assign_option}
                          onChange={(e) => onStaffDetail(e)}
                          value={assign}
                        />
                      </div>
                      <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">Contact Person</label>
                        <input
                          type="text"
                          placeholder="Enter Contact Person"
                          className="form-control"
                          value={provider_person}
                          onChange={(e) => setProviderPerson(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4 mt-2 mb-3">
                        <label htmlFor="">Contact</label>
                        <input
                          type="text"
                          placeholder="Enter Contact"
                          className="form-control"
                          value={provider_phone}
                          onChange={(e) => setProviderPhone(e.target.value)}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="">Email Id</label>
                        <input
                          type="email"
                          placeholder="Enter Email Id"
                          className="form-control"
                          value={provider_email}
                          onChange={(e) => setProviderEmail(e.target.value)}
                        />
                      </div>
                      {location?.value ? (
                        <>
                          <div className="col-md-8 mb-3">
                            <label htmlFor="">Address</label>
                            <input
                              type="text"
                              value={provider_address}
                              onChange={(e) =>
                                setProviderAddress(e.target.value)
                              }
                              placeholder="Enter Address"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6 mb-3 mb-md-0">
                            <label htmlFor="">Company Name</label>
                            <input
                              type="text"
                              value={provider_company}
                              onChange={(e) =>
                                setProviderCompany(e.target.value)
                              }
                              placeholder="Enter Company Name"
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-6 mb-3 mb-md-0">
                            <label htmlFor="">Website</label>
                            <input
                              type="text"
                              value={provider_website}
                              onChange={(e) =>
                                setProviderWebsite(e.target.value)
                              }
                              placeholder="Enter Website"
                              className="form-control"
                            />
                          </div>
                        </>
                      ) : null}
                    </Row>
                  </div>
                </Row>
              )}
              {template?.value !== "2" && (
                <Row className="bg-white px-2 py-4 shadow mb-3">
                  <div className="d-flex justify-content-between">
                    <h5 className="mb-3">Deliverables & testing</h5>
                    <a
                      onClick={() => onAddTestingRow()}
                      className="btn btn-purple btn-label"
                    >
                      <i className="fas fa-plus me-2 icon-size label-icon"></i>
                      Add New Row
                    </a>
                  </div>
                  <div className="responsive-table">
                    <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
                      <thead className="">
                        <tr>
                          <th>Sr No.</th>
                          <th>Milestone Description</th>
                          <th>Estimated Time (In Weeks)</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(testingRows || []).map((testingRow, key) => (
                          <tr key={key}>
                            <td className="col-1">
                              <input
                                type="number"
                                className="form-control"
                                name="sr_no"
                                onChange={(e) => onSrNo(e, key)}
                                value={testingRow["sr.no"] || ""}
                              />
                            </td>
                            <td className="col-8">
                              <input
                                type="text"
                                placeholder="Enter Description"
                                className="form-control"
                                name="milestone"
                                value={testingRow.milestone || ""}
                                onChange={(e) => onDescription(e, key)}
                              />
                            </td>
                            <td className="col-2">
                              <input
                                type="text"
                                placeholder="Enter Estimated Time"
                                className="form-control"
                                name="estimatedtime"
                                value={testingRow.estimatedtime || ""}
                                onChange={(e) => onTime(e, key)}
                              />
                            </td>
                            <td className="col-1 text-center">
                              {key !== 0 ? (
                                <a
                                  onClick={() => onDeleteTestingRow(key)}
                                  className="btn btn-danger"
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </a>
                              ) : (
                                "--"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Row>
              )}

              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between">
                  <h5 className="mb-3">Terms and agreement</h5>
                </div>
                <div className="responsive-table">
                  <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
                    <thead className="">
                      <tr>
                        <th>Sr No.</th>
                        <th>Particular</th>
                        <th>Currency</th>
                        <th>Total</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(termsRows || []).map((termsRow, key) => (
                        <tr key={key}>
                          <td className="col-1">
                            <input
                              type="number"
                              className="form-control"
                              name="sr_no"
                              value={termsRow.no}
                              onChange={(e) => onSrNoTerms(e, key)}
                            />
                          </td>
                          <td className="col-7">
                            <input
                              type="text"
                              placeholder="Enter Description"
                              className="form-control"
                              name="service"
                              value={termsRow.service}
                              onChange={(e) => onParticular(e, key)}
                            />
                          </td>
                          <td className="col-1">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="$"
                              name="currency"
                              value={currency?.symbol}
                              onChange={(e) => onCurrency(e, key)}
                              readOnly
                            />
                          </td>
                          <td className="col-2">
                            <input
                              type="text"
                              placeholder={
                                key == 0 ? "Estimated Time" : "Enter Total Cost"
                              }
                              className="form-control"
                              name="total"
                              value={termsRow.total}
                              onChange={(e) => onTotal(e, key)}
                            />
                          </td>
                          <td className="col-1 text-center">
                            {key == 0 ? (
                              <a
                                onClick={() => onAddTermsRow()}
                                className="btn btn-purple"
                              >
                                <i className="fas fa-plus"></i>
                              </a>
                            ) : null}
                            {key >= 3 ? (
                              <a
                                onClick={() => onDeleteTermsRow(termsRow.id)}
                                className="btn btn-danger"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </a>
                            ) : key != 0 ? (
                              "--"
                            ) : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Row>

  <Row className="bg-white px-2 py-4 shadow mb-3">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="mb-0">Project Objective</h5>
      <button
        type="button"
        className="btn btn-purple btn-label"
        onClick={generateObjective}
        disabled={isGeneratingObjective}
      >
        <i className={`fas ${isGeneratingObjective ? "fa-spinner fa-spin" : "fa-magic"} me-2 label-icon`}></i>
        {isGeneratingObjective ? "Generating..." : "Generate with AI"}
      </button>
    </div>
    <div className="col-md-12">
      <textarea
        className="form-control"
        rows={6}
        placeholder="AI-generated project objective will appear here. Click 'Generate with AI' or type manually."
        value={project_objective}
        onChange={(e) => setProjectObjective(e.target.value)}
      />
    </div>
  </Row>


              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between">
                  <h5 className="mb-3">Cost Breakdown</h5>
                  <a
                    onClick={() => onAddBreakdownRow()}
                    className="btn btn-purple btn-label"
                  >
                    <i className="fas fa-plus me-2 icon-size label-icon"></i>
                    Add New Row
                  </a>
                </div>
                <div className="responsive-table">
                  <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
                    <thead className="">
                      <tr>
                        <th>Sr No.</th>
                        <th>Description</th>
                        <th>Estimated Time (In Hours)</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(breakdownRows || []).map((breakdownRow, key) => (
                        <tr key={key}>
                          <td className="col-1">
                            <input
                              type="number"
                              className="form-control"
                              value={breakdownRow.sr_no || ""}
                              name="sr_no"
                              onChange={(e) => onSrnoBreak(e, key)}
                            />
                          </td>
                          <td className="col-8">
                            <input
                              type="text"
                              placeholder="Enter Description"
                              name="description"
                              onChange={(e) => onDescriptionCost(e, key)}
                              value={breakdownRow.description || ""}
                              className="form-control"
                            />
                          </td>
                          <td className="col-2">
                            <input
                              type="text"
                              placeholder="Enter Estimated Time"
                              className="form-control"
                              name="totalcost"
                              onChange={(e) => onTimeCost(e, key)}
                              value={breakdownRow.totalcost || ""}
                            />
                          </td>
                          <td className="col-1 text-center">
                            {key !== 0 ? (
                              <a
                                onClick={() => onDeleteBreakdownRow(key)}
                                className="btn btn-outline-danger"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Row>


              {template?.value !== "2" && (
  <Row className="bg-white px-2 py-4 shadow mb-3">
    <div className="d-flex justify-content-between mb-3">
      <h5 className="mb-0">Project Timeline</h5>
      <a
        onClick={() =>
          setTimelineRows([...timelineRows, { phase: "", duration: "", deliverables: "" }])
        }
        className="btn btn-purple btn-label"
      >
        <i className="fas fa-plus me-2 icon-size label-icon"></i>
        Add New Row
      </a>
    </div>
    <div className="responsive-table">
      <Table className="table table-bordered mb-0 mt-2">
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr No.</th>
            <th style={{ width: "22%" }}>Phase</th>
            <th style={{ width: "10%" }}>Duration</th>
            <th>Key Deliverables</th>
            <th style={{ width: "8%" }} className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {timelineRows.map((row, key) => (
            <tr key={key}>
              <td className="text-center align-middle">{key + 1}</td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Phase"
                  name="phase"
                  value={row.phase}
                  onChange={(e) => onTimelineChange(e, key)}
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. 1 or 2–3"
                  name="duration"
                  value={row.duration}
                  onChange={(e) => onTimelineChange(e, key)}
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter key deliverables"
                  name="deliverables"
                  value={row.deliverables}
                  onChange={(e) => onTimelineChange(e, key)}
                />
              </td>
              <td className="text-center align-middle">
                  <a
                    onClick={() => {
                      const updated = [...timelineRows];
                      updated.splice(key, 1);
                      setTimelineRows(updated);
                    }}
                    className="btn btn-danger"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </a>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  </Row>
)}

              {template?.value !== "2" && (
                <Row className="bg-white px-2 py-4 shadow mb-3">
                  <h5 className="mb-3">Conclusion</h5>
                  <div className="col-md-3 mt-2 mb-3 mb-md-0">
                    <label htmlFor="">Email Id</label>
                    <input
                      type="email"
                      placeholder="Enter Email Id"
                      className="form-control"
                      value={conclusion_email}
                      onChange={(e) => setConclusionEmail(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3 mt-2 mb-3 mb-md-0">
                    <label htmlFor="">Phone Number</label>
                    <input
                      type="text"
                      placeholder="Enter Phone no."
                      className="form-control"
                      value={conclusion_phone}
                      onChange={(e) => setConclusionPhone(e.target.value)}
                    />
                  </div>
                </Row>
              )}
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddProposal;
